const MOBILE_QUERY = window.matchMedia('(max-width: 768px)');

/**
 * @param {HTMLElement} slideshow
 */
function resetEqualize(slideshow) {
  const banner = slideshow.closest('.custom-banner');
  slideshow.style.removeProperty('--banner-mobile-slide-height');
  banner?.classList.remove('custom-banner--mobile-equalized', 'custom-banner--mobile-measuring');
}

/**
 * @param {HTMLElement} slide
 * @param {number} width
 */
function prepareSlideForMeasure(slide, width) {
  const state = {
    slide,
    hidden: slide.hidden,
    visibility: slide.style.visibility,
    position: slide.style.position,
    width: slide.style.width,
    height: slide.style.height,
    inert: slide.inert,
  };

  slide.hidden = false;
  slide.inert = true;
  slide.style.visibility = 'hidden';
  slide.style.position = 'absolute';
  slide.style.width = `${width}px`;
  slide.style.height = 'auto';
  slide.style.left = '0';
  slide.style.top = '0';

  return state;
}

/** @param {ReturnType<typeof prepareSlideForMeasure>} state */
function restoreSlideAfterMeasure(state) {
  const { slide, hidden, visibility, position, width, height, inert } = state;
  slide.hidden = hidden;
  slide.inert = inert;
  slide.style.visibility = visibility;
  slide.style.position = position;
  slide.style.width = width;
  slide.style.height = height;
  slide.style.removeProperty('left');
  slide.style.removeProperty('top');
}

/**
 * @param {HTMLElement} slideshow
 */
function equalizeMobileSlides(slideshow) {
  if (!MOBILE_QUERY.matches) {
    resetEqualize(slideshow);
    return;
  }

  const banner = slideshow.closest('.custom-banner');
  const scroller = slideshow.querySelector('slideshow-slides');
  const slides = /** @type {HTMLElement[]} */ ([...slideshow.querySelectorAll('slideshow-slide')]);

  if (!banner || !scroller || slides.length < 2) {
    resetEqualize(slideshow);
    return;
  }

  resetEqualize(slideshow);
  banner.classList.add('custom-banner--mobile-measuring');

  const width = scroller.clientWidth;
  let maxHeight = 0;

  for (const slide of slides) {
    const layout = slide.querySelector('.custom-banner__layout');
    if (!layout) continue;

    const state = prepareSlideForMeasure(slide, width);
    maxHeight = Math.max(maxHeight, layout.getBoundingClientRect().height);
    restoreSlideAfterMeasure(state);
  }

  banner.classList.remove('custom-banner--mobile-measuring');

  if (maxHeight <= 0) return;

  banner.classList.add('custom-banner--mobile-equalized');
  slideshow.style.setProperty('--banner-mobile-slide-height', `${Math.ceil(maxHeight)}px`);
}

/** @param {HTMLElement} slideshow */
function observeSlideshow(slideshow) {
  if (slideshow.dataset.customBannerEqualizeInit === 'true') return;
  slideshow.dataset.customBannerEqualizeInit = 'true';

  const banner = slideshow.closest('.custom-banner');
  if (!banner) return;

  const run = () => equalizeMobileSlides(slideshow);
  run();

  const ro = new ResizeObserver(() => {
    window.requestAnimationFrame(run);
  });

  ro.observe(banner);
  for (const layout of slideshow.querySelectorAll('.custom-banner__layout')) {
    ro.observe(layout);
  }

  MOBILE_QUERY.addEventListener('change', run);
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const slideshow = target.closest(
      'slideshow-component.custom-banner__slideshow[data-custom-banner-equalize-mobile]'
    );
    if (slideshow instanceof HTMLElement) equalizeMobileSlides(slideshow);
  });
}

function initFromRoot(root = document) {
  for (const slideshow of root.querySelectorAll(
    'slideshow-component.custom-banner__slideshow[data-custom-banner-equalize-mobile]'
  )) {
    if (slideshow instanceof HTMLElement) observeSlideshow(slideshow);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFromRoot());
} else {
  initFromRoot();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) initFromRoot(event.target);
});
